module.exports = __webpack_public_path__ + "img/book.d46fcec6.jpg";